import { render, staticRenderFns } from "./HelpCard.vue?vue&type=template&id=390e6bcf&"
import script from "./HelpCard.vue?vue&type=script&lang=js&"
export * from "./HelpCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports